export default "__VITE_ASSET__C3h2V5K___"